/**
 * Base URL for API requests.
 *
 * Development (`npm start`): empty string → requests are same-origin (`/api/...`)
 * and Create React App's `package.json` `proxy` forwards them to the real API.
 * That avoids CORS when the SPA runs on http://localhost:3000.
 *
 * Production build: defaults to the deployed API unless you set
 * `REACT_APP_API_BASE_URL` (e.g. in `.env.production`).
 */
function stripTrailingSlash(url) {
  if (!url) return '';
  return url.replace(/\/$/, '');
}

function resolveApiBase() {
  if (process.env.REACT_APP_API_BASE_URL !== undefined) {
    return stripTrailingSlash(process.env.REACT_APP_API_BASE_URL);
  }
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  return 'https://api.telarica-egypt.com';
}

export const API_BASE = resolveApiBase();

/** @param {string} path Must start with `/`, e.g. `/api/login/` */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${p}`;
}
